/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class PinterestOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy="Select a Pinterest Board"/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={(
                        <p className="chooser-notice">You've already connected all your Pinterest Boards to dlvr.it</p>
                    )}
                    noSubaccountMessage={(
                        <p className="chooser-notice no-accounts">
                            We were unable to locate any Pinterest boards that could be connected to dlvr.it.<br/><br/>
                            If you haven't created any boards in your profile, check out the guide below.<br/><br/>
                            <a href="https://support.dlvrit.com/hc/en-us/articles/360018626794-Why-can-t-I-connect-to-my-Pinterest-page-" target="_blank">Learn more about common Pinterest connection issues.</a>
                        </p>
                    )}
                    typeLabel="Pinterest Board"/>
            </div>
        );
    }
}

PinterestOutput.displayName = "PinterestOutput";

export default PinterestOutput;
